export default __webpack_public_path__ + "static/media/Blog11.6a6bcd8d.png";